var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Product"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product",
    clipPath: "url(#clip-Product)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Buy",
    "data-name": "Iconly/Light-Outline/Buy",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buy",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M3.919,11.607a.886.886,0,1,1-.886.886A.887.887,0,0,1,3.919,11.607Zm7.724,0a.886.886,0,1,1-.886.886A.887.887,0,0,1,11.643,11.607ZM.991.006,2.415.253a.516.516,0,0,1,.424.464L3,2.634h9.854a1.433,1.433,0,0,1,1.215,1.623l-.65,4.49a1.754,1.754,0,0,1-1.728,1.5H4.214a1.754,1.754,0,0,1-1.739-1.6L1.848,1.2.816,1.019A.515.515,0,0,1,.4.425.52.52,0,0,1,.991.006Zm2.47,3.655H3.086L3.5,8.572a.714.714,0,0,0,.716.661h7.475a.722.722,0,0,0,.712-.618l.651-4.491a.4.4,0,0,0-.077-.3.4.4,0,0,0-.266-.158H3.461Zm7.13,1.5a.514.514,0,1,1,0,1.027h-1.9a.514.514,0,1,1,0-1.027Z",
    transform: "translate(-0.39 0)",
    fill: "#a2a2a2",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/Product.c704374fb5750dc76de360356272d341.svg";
export { ForwardRef as ReactComponent };